import React, { useState, useEffect, useCallback, useRef } from "react";
import Sidebar from '../components/layout/Sidebar';
import { AUTH_STORAGE_KEY } from "../socket"; // ← FIX: use the real key, not hardcoded "KRIVA_AUTH"
import "./ServiceList.css";
import MobileBottomNav from '../components/layout/MobileBottomNav';
import { useNavigate } from "react-router-dom";

const emptyBusinessForm = {
  businessName: "",
  category: "", phone: "", experience: "",
  description: "", homeVisit: false, area: "", city: "", photo: null,
  photoUrl: "",
  lat: "", lng: "",certificate:null,
 license:null
};
const actionBtn = {
  width: 36,
  height: 36,
  borderRadius: '50%',
  border: 'none',
  background: 'rgba(148,163,184,0.12)',
  color: '#e2e8f0',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};
const emptyCatalogForm = {
  businessId: "",
  catalogCategory: "",
  catalogTitle: "",
  catalogDescription: "",
  catalogPrice: "",
  catalogPhoto: null,
  catalogPhotoUrl: "",
};

const emptySEOCategoryForm = {
  seoName: "",
  seoDescription: "",
  seoKeywords: "",
};

// ── Auth helpers (always read fresh) ────────────────────────────────────────
function getToken() {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY); // ← FIX
    return raw ? JSON.parse(raw)?.token : null;
  } catch { return null; }
}

function authHeader() {                       // ← renamed to avoid confusion
  const token = getToken();
  return token ? { Authorization: "Bearer " + token } : {};
}

// ── Badge colors ─────────────────────────────────────────────────────────────
const CATEGORY_COLORS = {
  Plumber:            { bg: "#0c2a3d", border: "#0ea5e9", text: "#38bdf8" },
  Electrician:        { bg: "#2d1a00", border: "#f59e0b", text: "#fbbf24" },
  Carpenter:          { bg: "#1a0d2e", border: "#a855f7", text: "#c084fc" },
  Painter:            { bg: "#0d2218", border: "#22c55e", text: "#4ade80" },
  Cleaner:            { bg: "#1e1233", border: "#6366f1", text: "#818cf8" },
  "AC Repair":        { bg: "#00213d", border: "#06b6d4", text: "#22d3ee" },
  "Appliance Repair": { bg: "#1f1200", border: "#f97316", text: "#fb923c" },
  "Pest Control":     { bg: "#1a0000", border: "#ef4444", text: "#f87171" },
  Security:           { bg: "#001a1a", border: "#14b8a6", text: "#2dd4bf" },
  Other:              { bg: "#1a1a2e", border: "#64748b", text: "#94a3b8" },
};
const categoryStyle = cat => CATEGORY_COLORS[cat] || CATEGORY_COLORS.Other;

function BusinessCategoryCard({ service, seoCategories, authHeader, showToast, fetchServices }) {
  const selectedCats = String(service.category || "").split(",").map(c => c.trim()).filter(Boolean);
  const [localSelected, setLocalSelected] = React.useState(selectedCats);
  const [saving, setSaving] = React.useState(false);
  const [searchCategory, setSearchCategory] = React.useState("");
  const handleToggle = (name) => {
  setLocalSelected(prev => {

    if (prev.includes(name)) {
      return prev.filter(x => x !== name);
    }

    if (prev.length >= 6) {
      showToast("Maximum 6 SEO categories allowed.", "error");
      return prev;
    }

    return [...prev, name];
  });
};

  const handleSave = async () => {
    if (localSelected.length === 0) {
      showToast("Select at least one category.", "error");
      return;
    }
    setSaving(true);
    const fd = new FormData();
    fd.append("category", localSelected.join(", "));
    try {
      const res = await fetch(`/api/services/${service._id}`, {
        method: "PUT",
        headers: authHeader(),
        body: fd,
      });
      if (res.status === 401) { showToast("Session expired.", "error"); setSaving(false); return; }
      const data = await res.json();
      if (data.success) {
        showToast(`Categories saved for ${service.businessName}!`);
        await fetchServices();
      } else {
        showToast(data.message || "Failed to save.", "error");
      }
    } catch {
      showToast("Failed to save categories.", "error");
    }
    setSaving(false);
  };

  return (
    <div style={{ backgroundColor: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', padding: 20, boxShadow: '0 2px 8px #0001' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
        {service.photoUrl && (
          <img src={service.photoUrl} alt={service.businessName} style={{ width: 48, height: 48, borderRadius: 8, objectFit: 'cover', border: '1px solid #e2e8f0' }} />
        )}
        <div>
          <div style={{ fontWeight: 700, fontSize: 16, color: '#0f172a' }}>{service.businessName}</div>
          {service.area && <div style={{ fontSize: 12, color: '#64748b' }}>{service.area}</div>}
        </div>
      </div>
<div style={{ marginBottom: 12 }}>
  <input
    type="text"
    placeholder="Search category..."
    value={searchCategory}
    onChange={(e) => setSearchCategory(e.target.value)}
    style={{
      width: "100%",
      padding: "10px 12px",
      border: "1px solid #cbd5e1",
      borderRadius: 8,
      fontSize: 14,
      outline: "none",
    }}
  />
</div>
      <div style={{ marginBottom: 12 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 8 }}>
          Categories <span style={{ color: '#ef4444' }}>*</span>
        </div>
        <div
  style={{
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    maxHeight: "220px",
    overflowY: "auto",
    paddingRight: "6px",
  }}
>
          {(
  (seoCategories && seoCategories.length
    ? seoCategories
    : [
        "Plumber",
        "Electrician",
        "Carpenter",
        "Painter",
        "Cleaning",
        "AC Repair",
        "Appliance Repair",
        "Pest Control",
        "Security",
        "Other"
      ]
  )
  .filter(c => {
    const name =
      typeof c === "string"
        ? c
        : (c.name || c.category || String(c));

    return name
      .toLowerCase()
      .includes(searchCategory.toLowerCase());
  })
).map(c => {
            const name = typeof c === 'string' ? c : (c.name || c.category || String(c));
            const checked = localSelected.includes(name);
            return (
              <label key={name} style={{
                display: 'flex', alignItems: 'center', gap: 5,
                padding: '6px 14px', borderRadius: 20,
                border: `1.5px solid ${checked ? '#0ea5e9' : '#cbd5e1'}`,
                background: checked ? '#e0f2fe' : 'transparent',
                cursor: 'pointer', fontSize: 13,
                color: checked ? '#0369a1' : '#64748b',
                fontWeight: checked ? 600 : 400,
                userSelect: 'none',
                transition: 'all 0.15s ease',
              }}>
                <input
                  type="checkbox"
                  style={{ display: 'none' }}
                  checked={checked}
                  onChange={() => handleToggle(name)}
                />
                {name}
              </label>
            );
          })}
        </div>
        {localSelected.length === 0 && (
          <small style={{ color: '#ef4444', marginTop: 6, display: 'block' }}>Select at least one category.</small>
        )}
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button
          onClick={handleSave}
          disabled={saving}
          style={{
            padding: '8px 20px', borderRadius: 8,
            backgroundColor: saving ? '#cbd5e1' : '#0ea5e9',
            color: '#fff', border: 'none',
            cursor: saving ? 'not-allowed' : 'pointer',
            fontWeight: 600, fontSize: 14,
          }}
          onMouseOver={e => !saving && (e.currentTarget.style.backgroundColor = '#0284c7')}
          onMouseOut={e => !saving && (e.currentTarget.style.backgroundColor = '#0ea5e9')}
        >
          {saving
            ? <><i className="fa-solid fa-circle-notch fa-spin" style={{ marginRight: 6 }} />Saving…</>
            : <><i className="fa-solid fa-check" style={{ marginRight: 6 }} />Save Categories</>
          }
        </button>
      </div>
    </div>
  );
}
// ─────────────────────────────────────────────────────────────────────────────
export default function ServiceManagePage( setVideoCall, setVoiceCall ,onOpenComposeModal) {
  const [role, setRole] = useState(3);
  const navigate = useNavigate();
  const [services,   setServices]   = useState([]);
  const [loading,    setLoading]    = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [deleting,   setDeleting]   = useState(null);
  const [showModal,  setShowModal]  = useState(false);
  const [modalMode,  setModalMode]  = useState("business");
  const [editing,    setEditing]    = useState(null);
  const [editingCatalogIndex, setEditingCatalogIndex] = useState(null);
  const [form,       setForm]       = useState(emptyBusinessForm);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [editorOpen, setEditorOpen] = useState(false);
  const [editorImage, setEditorImage] = useState(null);
  const [editorScale, setEditorScale] = useState(1);
  const [editorRotate, setEditorRotate] = useState(0);
  const canvasRef = useRef(null);
  const [editorImageSrc, setEditorImageSrc] = useState(null);
  const [editorImageSrcIsObjectUrl, setEditorImageSrcIsObjectUrl] = useState(false);
  const [editorOffsetX, setEditorOffsetX] = useState(0);
  const [editorOffsetY, setEditorOffsetY] = useState(0);
  const [editorDragging, setEditorDragging] = useState(false);
  const editorDragStart = useRef({ x: 0, y: 0, ox: 0, oy: 0 });
  const EDITOR_CANVAS_W = 600;
  const [hoveredLead, setHoveredLead] = useState(null);
const resolveEnvLimit = (primaryValue, fallbackValue, legacyValue) => {
  const rawValue = [primaryValue, legacyValue].find((value) => {
    if (value === undefined || value === null) return false;
    const trimmed = String(value).trim();
    return trimmed !== "";
  });

  const parsedValue = Number(rawValue ?? fallbackValue);
  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : fallbackValue;
};

const MAX_BUSINESSES = resolveEnvLimit(
  process.env.REACT_APP_MAX_BUSINESSES_PER_USER,
  1,
  process.env.MAX_BUSINESSES_PER_USER
);
const MAX_CATALOG = resolveEnvLimit(
  process.env.REACT_APP_MAX_CATALOG_ITEMS || process.env.REACT_APP_MAX_CATALOG_ITEMS_PER_BUSINESS,
  10,
  process.env.MAX_CATALOG_ITEMS_PER_BUSINESS || process.env.MAX_CATALOG_ITEMS
);
const EDITOR_CANVAS_H = 400;  // ~3:2 ratio matching the service cards
  const [search,           setSearch]           = useState("");
  const [filterCategories, setFilterCategories] = useState([]);
  const [categoryModalService, setCategoryModalService] = useState(null);
  const [categoryModalSelected, setCategoryModalSelected] = useState([]);
  const [toast,            setToast]            = useState(null);
  const [categories,       setCategories]       = useState([]);
  // Bookings state
  const [bookings, setBookings] = useState([]);
  const [loadingBookings, setLoadingBookings] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  // Tab state
  const [seoCategories, setSeoCategories] = useState([]);
  const [loadingSeo, setLoadingSeo] = useState(false);
  const [activeTab, setActiveTab] = useState("business"); // "business" | "leads" | "catalog" | "reviews" | "messages" | "earnings" | "settings"
// ── CHANGE THIS ─────────────────────────────────────────────────────────────
const fetchBookings = useCallback(async () => {
  const token = getToken();
  if (!token) return;
  setLoadingBookings(true);
  try {
    const res = await fetch("/api/bookings/for-my-services", { // ← was "/api/bookings"
      headers: authHeader()
    });
    if (res.status === 401) { setBookings([]); setLoadingBookings(false); return; }
    const data = await res.json();
    setBookings(Array.isArray(data.bookings) ? data.bookings : []);
  } catch (err) {
    setBookings([]);
  }
  setLoadingBookings(false);
}, []);

  // ── Toast ─────────────────────────────────────────────────────────────────
  const showToast = useCallback((msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3200);
  }, []);

  // ── Fetch services ────────────────────────────────────────────────────────
  const fetchServices = useCallback(async () => {
    const token = getToken();
    if (!token) { showToast("Not logged in.", "error"); return; }

    setLoading(true);
    try {
      const res  = await fetch("/api/services", { headers: authHeader() });

      if (res.status === 401) {
        showToast("Session expired. Please log in again.", "error");
        setServices([]);
        setLoading(false);
        return;
      }

      const data = await res.json();
      setServices(Array.isArray(data.services) ? data.services : []);
    } catch (err) {
      console.error("[fetchServices]", err);
      showToast("Failed to load services.", "error");
      setServices([]);
    }
    setLoading(false);
  }, [showToast]);


const fetchSeoCategories = useCallback(async () => {
  try {
    const res = await fetch('/api/seo-categories', {
      headers: authHeader()
    });

    const data = await res.json();

    setSeoCategories(
      Array.isArray(data.categories)
        ? data.categories
        : []
    );
  } catch {
    setSeoCategories([]);
  }
}, []);
  const fetchCategories = useCallback(async () => {
    try {
      const res = await fetch('/api/service-categories', { headers: authHeader() });
      if (res.status === 401) { setCategories([]); return; }
      const data = await res.json();
      const list = Array.isArray(data.categories) ? data.categories : (Array.isArray(data) ? data : (data?.categories || []));
      setCategories(list);
    } catch (err) {
      console.error('[fetchCategories]', err);
      setCategories([]);
    }
  }, []);

  useEffect(() => { fetchServices(); fetchBookings(); fetchCategories();fetchSeoCategories(); }, [fetchServices, fetchBookings, fetchCategories,fetchSeoCategories]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      const user = parsed?.user || {};
      setRole(Number(user.role) || (user.isAdmin ? 2 : 3));
    } catch (err) {
      setRole(3);
    }
  }, []);

  const openCategoryModal = (service) => {
    const values = String(service.category || "").split(",").map(c => c.trim()).filter(Boolean);
    setCategoryModalService(service);
    setCategoryModalSelected(values);
  };

  const closeCategoryModal = () => {
    setCategoryModalService(null);
    setCategoryModalSelected([]);
  };

  const handleCategoryModalChange = (e) => {
    const values = Array.from(e.target.selectedOptions || []).map(o => o.value);
    setCategoryModalSelected(values);
  };

  const saveBusinessCategories = async () => {
    if (!categoryModalService) return;
    if (categoryModalSelected.length === 0) {
      showToast("Select at least one category.", "error");
      return;
    }

    const fd = new FormData();
    fd.append("category", categoryModalSelected.join(", "));
    try {
      const res = await fetch(`/api/services/${categoryModalService._id}`, {
        method: "PUT",
        headers: authHeader(),
        body: fd,
      });
      if (res.status === 401) {
        showToast("Session expired.", "error");
        return;
      }
      const data = await res.json();
      if (data.success) {
        showToast("Business categories updated.");
        closeCategoryModal();
        await fetchServices();
      } else {
        showToast(data.message || "Failed to save categories.", "error");
      }
    } catch (err) {
      console.error("[saveBusinessCategories]", err);
      showToast("Failed to save categories.", "error");
    }
  };

  // ── Filter ────────────────────────────────────────────────────────────────
  const visible = services.filter(s => {
    const categories = String(s.category || "").split(",").map(c => c.trim()).filter(Boolean);
    const selected = filterCategories.map(c => c.toLowerCase());
    const matchCat = selected.length === 0 || categories.some(c => selected.includes(c.toLowerCase()));
    const matchText = !search || [s.businessName, s.category, s.description, s.area, s.phone]
      .some(f => String(f || "").toLowerCase().includes(search.toLowerCase()));
    return matchCat && matchText;
  });

  const catalogItems = services.flatMap(service => {
    return (Array.isArray(service.catalogItems) ? service.catalogItems : []).map(item => ({
      ...item,
      businessName: service.businessName || "",
      serviceCategory: service.category || "",
      serviceId: service._id,
    }));
  });

 useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 640);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // ── Form ──────────────────────────────────────────────────────────────────
  const handleChange = e => {
    const { name, value, type, checked, files, selectedOptions, multiple } = e.target;
    if(type==="file"){

 setForm(prev=>({

   ...prev,

   [name]:files[0]

 }));

}
    if (type === "checkbox") {
      setForm(p => ({ ...p, [name]: checked }));
    } else if (type === "file") {
      const file = files[0];
      const photoField = modalMode === "catalog" ? "catalogPhoto" : "photo";
      const photoUrlField = modalMode === "catalog" ? "catalogPhotoUrl" : "photoUrl";
      setForm(p => ({ ...p, [photoField]: file, [photoUrlField]: "" }));
      // create preview URL
      if (file) {
        try { URL.revokeObjectURL(previewUrl); } catch (e) {}
        const url = URL.createObjectURL(file);
        setPreviewUrl(url);
         const img = new Image();
  img.onload = () => {
    setEditorImage(img);
    setEditorImageSrc(url);
    setEditorImageSrcIsObjectUrl(true);
    setEditorScale(1);
    setEditorRotate(0);
    setEditorOffsetX(0);
    setEditorOffsetY(0);
    setEditorOpen(true);
  };
  img.src = url;
      } else {
        try { URL.revokeObjectURL(previewUrl); } catch (e) {}
        setPreviewUrl(null);
      }
    } else if (multiple) {
      const values = Array.from(selectedOptions || []).map(o => o.value);
      setForm(p => ({ ...p, [name]: values }));
    } else {
      setForm(p => ({ ...p, [name]: value }));
    }
  };

  const addCatalogItem = () => {
    setForm(p => ({
      ...p,
      catalogItems: [
        ...p.catalogItems,
        {
          category: "",
          title: "",
          description: "",
          price: "",
          photo: null,
          photoUrl: "",
          previewUrl: null,
        },
      ],
    }));
  };
  
  const makeVoiceCall = (email) => {
    const e = typeof email === "string" ? email : email?.emails?.[0] || email?.userId;
    if (!e || !setVoiceCall) return;
    setVoiceCall({ remoteUser: e, isCaller: true, type: "voice" });
  };

  const makeVideoCall = (email) => {
    const e = typeof email === "string" ? email : email?.emails?.[0] || email?.userId;
    if (!e || !setVideoCall) return;
    setVideoCall({ remoteUser: e, isCaller: true, type: "video" });
  };


  /* ── handlers ───────────────────────────────────────────────── */
  const handleChat = (contact) => {
    navigate("/kmail/Krivachat", {
      state: { email: contact.emails?.[0] || contact.userId, name: contact.name || contact.fullName }
    });
  };
  const updateCatalogItem = (index, field, value) => {
    setForm(prev => {
      const items = [...prev.catalogItems];
      items[index] = { ...items[index], [field]: value };
      return { ...prev, catalogItems: items };
    });
  };

  const updateCatalogItemPhoto = (index, file) => {
    setForm(prev => {
      const items = [...prev.catalogItems];
      const item = { ...items[index] };
      if (item.previewUrl) {
        try { URL.revokeObjectURL(item.previewUrl); } catch (e) {}
      }
      item.photo = file || null;
      item.photoUrl = file ? "" : item.photoUrl;
      item.previewUrl = file ? URL.createObjectURL(file) : null;
      items[index] = item;
      return { ...prev, catalogItems: items };
    });
  };

  const removeCatalogItem = index => {
    setForm(prev => {
      const items = [...prev.catalogItems];
      const item = items[index];
      if (item?.previewUrl) {
        try { URL.revokeObjectURL(item.previewUrl); } catch (e) {}
      }
      items.splice(index, 1);
      return { ...prev, catalogItems: items };
    });
  };

  // Open simple editor: load image into an <img> then canvas
  const openEditor = () => {
    
    const photoField = modalMode === "catalog" ? "catalogPhoto" : "photo";
    const photoUrlField = modalMode === "catalog" ? "catalogPhotoUrl" : "photoUrl";
    const file = form[photoField];
    const src = file ? URL.createObjectURL(file) : form[photoUrlField];
    if (!src) return showToast('No image to edit.', 'error');
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      setEditorImage(img);
      setEditorImageSrc(src);
      setEditorImageSrcIsObjectUrl(!!file);
      setEditorScale(1);
      setEditorRotate(0);
      setEditorOffsetX(0);
      setEditorOffsetY(0);
      setEditorOpen(true);
    };
    img.onerror = () => showToast('Failed to load image.', 'error');
    img.src = src;
  };

  const startDrag = (clientX, clientY) => {
    editorDragStart.current = { x: clientX, y: clientY, ox: editorOffsetX, oy: editorOffsetY };
    setEditorDragging(true);
  };
  const moveDrag = (clientX, clientY) => {
    if (!editorDragging) return;
    const dx = clientX - editorDragStart.current.x;
    const dy = clientY - editorDragStart.current.y;
    setEditorOffsetX(editorDragStart.current.ox + dx);
    setEditorOffsetY(editorDragStart.current.oy + dy);
  };
  const endDrag = () => setEditorDragging(false);

  useEffect(() => {
    if (!editorOpen && editorImageSrc) {
      if (editorImageSrcIsObjectUrl) {
        try { URL.revokeObjectURL(editorImageSrc); } catch (e) {}
      }
      setEditorImage(null);
      setEditorImageSrc(null);
      setEditorImageSrcIsObjectUrl(false);
    }
  }, [editorOpen, editorImageSrc, editorImageSrcIsObjectUrl]);

  const saveEditedImage = async (canvas) => {
    return new Promise((resolve, reject) => {
      canvas.toBlob(async blob => {
        if (!blob) return reject(new Error('Failed to encode image'));
        const photoField = modalMode === "catalog" ? "catalogPhoto" : "photo";
        const photoUrlField = modalMode === "catalog" ? "catalogPhotoUrl" : "photoUrl";
        const editedFile = new File([blob], form[photoField]?.name || 'photo.jpg', { type: blob.type });
        setForm(p => ({ ...p, [photoField]: editedFile, [photoUrlField]: "" }));
        try { URL.revokeObjectURL(previewUrl); } catch (e) {}
        const url = URL.createObjectURL(editedFile);
        setPreviewUrl(url);
        resolve();
      }, 'image/jpeg', 0.9);
    });
  };
      useEffect(() => {
      if (!editorOpen || !editorImage || !canvasRef.current) return;
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      const img = editorImage;

      canvas.width = EDITOR_CANVAS_W;
      canvas.height = EDITOR_CANVAS_H;
      ctx.save();
      ctx.clearRect(0, 0, EDITOR_CANVAS_W, EDITOR_CANVAS_H);

      const baseRatio = Math.max(EDITOR_CANVAS_W / img.width, EDITOR_CANVAS_H / img.height, 0.0001);
      const drawW = img.width * baseRatio * editorScale;
      const drawH = img.height * baseRatio * editorScale;

      ctx.translate(EDITOR_CANVAS_W / 2 + editorOffsetX, EDITOR_CANVAS_H / 2 + editorOffsetY);
      ctx.rotate((editorRotate * Math.PI) / 180);
      ctx.drawImage(img, -drawW / 2, -drawH / 2, drawW, drawH);
      ctx.restore();
    }, [editorOpen, editorImage, editorScale, editorRotate, editorOffsetX, editorOffsetY]);
  // Auto-fill lat/lng using browser geolocation
  const handleUseLocation = () => {
    if (!navigator.geolocation) {
      showToast("Geolocation not supported.", "error");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      pos => {
        setForm(p => ({
          ...p,
          lat: pos.coords.latitude.toFixed(6),
          lng: pos.coords.longitude.toFixed(6),
        }));
        showToast("Location filled.");
      },
      err => {
        showToast("Could not get location.", "error");
      }
    );
  };

  const openAdd  = () => {
    if (services.length >= MAX_BUSINESSES) {
    showToast(`You can only create ${MAX_BUSINESSES} business${MAX_BUSINESSES === 1 ? "" : "es"}.`, "error");
    return;
  }
    setModalMode("business");
    setEditing(null);
    setEditingCatalogIndex(null);
    setForm(emptyBusinessForm);
    setPreviewUrl(null);
    setShowModal(true);
  };

  const openAddCatalogItem = () => {
     const totalCatalogItems = services.reduce((sum, s) => sum + (s.catalogItems?.length || 0), 0);
  // If only 1 business allowed, check that business's catalog count
  const targetService = services[0];
  const currentCount = targetService ? (targetService.catalogItems?.length || 0) : 0;
  if (currentCount >= MAX_CATALOG) {
    showToast(`Maximum ${MAX_CATALOG} catalog items allowed per business.`, "error");
    return;
  }
    setModalMode("catalog");
    setEditing(null);
    setEditingCatalogIndex(null);
    setForm(emptyCatalogForm);
    setPreviewUrl(null);
    setShowModal(true);
  };

  const openEdit = s  => {
    setModalMode("business");
    setEditing(s._id);
    setEditingCatalogIndex(null);
    setForm({
      businessName: s.businessName || "",
      category: String(s.category || "").split(",").map(c => c.trim()).filter(Boolean)[0] || "",
      phone: s.phone || "",
      experience: s.experience || "",
      description: s.description || "",
      homeVisit: !!s.homeVisit,
      area: s.area || "",
      city: s.city || "",
      photo: null,
      photoUrl: s.photoUrl || "",
      lat: s.lat || "",
      lng: s.lng || "",
    });
    setPreviewUrl("");
    setShowModal(true);
  };

  const openEditCatalogItem = (serviceId, item, index) => {
    setModalMode("catalog");
    setEditing(serviceId);
    setEditingCatalogIndex(index);
    setForm({
      businessId: serviceId,
      catalogCategory: item.category || "",
      catalogTitle: item.title || "",
      catalogDescription: item.description || "",
      catalogPrice: item.price || "",
      catalogPhoto: null,
      catalogPhotoUrl: item.photoUrl || "",
    });
    setPreviewUrl(item.photoUrl || null);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingCatalogIndex(null);
  };

  // ── Delete ────────────────────────────────────────────────────────────────
  const handleDelete = async id => {
    if (!window.confirm("Delete this service?")) return;
    setDeleting(id);
    try {
      const res = await fetch(`/api/services/${id}`, { method: "DELETE", headers: authHeader() });
      if (res.status === 401) { showToast("Session expired.", "error"); return; }
      const data = await res.json();
      if (data.success) {
        setServices(p => p.filter(s => s._id !== id));
        showToast("Service deleted.");
      } else {
        showToast(data.message || "Delete failed.", "error");
      }
    } catch { showToast("Delete failed.", "error"); }
    setDeleting(null);
  };

  const handleRemoveCatalogItem = async (serviceId, index) => {
    if (!window.confirm("Remove this catalog item?")) return;
    const service = services.find(s => s._id === serviceId);
    if (!service) {
      showToast("Business not found.", "error");
      return;
    }

    const updatedItems = Array.isArray(service.catalogItems) ? [...service.catalogItems] : [];
    if (index < 0 || index >= updatedItems.length) {
      showToast("Catalog item not found.", "error");
      return;
    }
    updatedItems.splice(index, 1);

    const fd = new FormData();
    fd.append("catalogItems", JSON.stringify(updatedItems));

    try {
      const res = await fetch(`/api/services/${serviceId}`, { method: "PUT", headers: authHeader(), body: fd });
      if (res.status === 401) { showToast("Session expired.", "error"); return; }
      const data = await res.json();
      if (data.success) {
        await fetchServices();
        showToast("Catalog item removed.");
      } else {
        showToast(data.message || "Remove failed.", "error");
      }
    } catch (err) {
      console.error('[handleRemoveCatalogItem]', err);
      showToast("Remove failed.", "error");
    }
  };

  // ── Submit (create / update) ──────────────────────────────────────────────
  const handleSubmit = async e => {
    e.preventDefault();

    const token = getToken();
    if (!token) { showToast("Not logged in.", "error"); return; }

    setSubmitting(true);
    try {
      if (modalMode === "business") {
if (!form.category || form.category.trim() === "") {
  showToast("Please select a category.", "error");
  return;
}
        const fd = new FormData();
        Object.entries(form).forEach(([k, v]) => {
          if (v === null || v === undefined) return;
          fd.append(k, k === "homeVisit" ? String(v) : v);
        });

        const url = editing ? `/api/services/${editing}` : "/api/services";
        const method = editing ? "PUT" : "POST";

        if (form.photo) {
          fd.append("photo", form.photo);
        }
        
        if(form.certificate)
fd.append(
 "certificate",
 form.certificate
);

if(form.license)
fd.append(
 "license",
 form.license
);

        const res = await fetch(url, { method, headers: authHeader(), body: fd });
        if (res.status === 401) { showToast("Session expired.", "error"); setSubmitting(false); return; }

        const data = await res.json();
        if (data.success) {
          await fetchServices();
          setShowModal(false);
          showToast(editing ? "Business updated!" : "Business added!");
        } else {
          showToast(data.message || "Save failed.", "error");
        }
      } else if (modalMode === "catalog") {
        if (!form.businessId) {
          showToast("Select a business first.", "error");
          setSubmitting(false);
          return;
        }

        const targetService = services.find(s => s._id === form.businessId);
        if (!targetService) {
          showToast("Selected business not found.", "error");
          setSubmitting(false);
          return;
        }

        const editedIndex = editingCatalogIndex;
        const itemToSave = {
          category: form.catalogCategory || "",
          title: form.catalogTitle || "",
          description: form.catalogDescription || "",
          price: form.catalogPrice || "",
          photoUrl: form.catalogPhoto ? "" : (form.catalogPhotoUrl || ""),
        };

        const catalogItems = Array.isArray(targetService.catalogItems) ? [...targetService.catalogItems] : [];
        if (editedIndex !== null && editedIndex >= 0 && editedIndex < catalogItems.length) {
          catalogItems[editedIndex] = itemToSave;
        } else {
          catalogItems.push(itemToSave);
        }

        const fd = new FormData();
        fd.append("catalogItems", JSON.stringify(catalogItems));

        if (form.catalogPhoto) {
          const photoField = `catalogPhoto_${editedIndex !== null && editedIndex >= 0 ? editedIndex : catalogItems.length - 1}`;
          fd.append(photoField, form.catalogPhoto);
        }

        const res = await fetch(`/api/services/${form.businessId}`, { method: "PUT", headers: authHeader(), body: fd });
        if (res.status === 401) { showToast("Session expired.", "error"); setSubmitting(false); return; }

        const data = await res.json();
        if (data.success) {
          await fetchServices();
          setShowModal(false);
          showToast(editedIndex !== null && editedIndex >= 0 ? "Catalog item updated!" : "Catalog item added!");
        } else {
          showToast(data.message || "Save failed.", "error");
        }
      } else if (modalMode === "seocategory") {
        if (!form.seoName || form.seoName.trim() === "") {
          showToast("Please enter SEO category name.", "error");
          setSubmitting(false);
          return;
        }

        const seoData = {
          seoName: form.seoName,
          seoDescription: form.seoDescription || "",
          seoKeywords: form.seoKeywords || "",
        };

        const url = editing ? `/api/services/${editing}` : "/api/services";
        const method = editing ? "PUT" : "POST";

        const res = await fetch(url, {
          method,
          headers: { ...authHeader(), "Content-Type": "application/json" },
          body: JSON.stringify(seoData),
        });

        if (res.status === 401) { showToast("Session expired.", "error"); setSubmitting(false); return; }

        const data = await res.json();
        if (data.success) {
          await fetchServices();
          setShowModal(false);
          showToast(editing ? "SEO category updated!" : "SEO category added!");
        } else {
          showToast(data.message || "Save failed.", "error");
        }
      }
    } catch (err) {
      console.error("[handleSubmit]", err);
      showToast("Error saving.", "error");
    }
    setSubmitting(false);
  };

  // ── Render ────────────────────────────────────────────────────────────────
  return (
   <div style={{ display: 'flex', height: '150vh', overflow: 'hidden' }}>

     {!isMobile && <Sidebar role={role} />}
   <div
  className="svc-page"
  style={{
    flex: 1,
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative'
  }}
>
        {/* ── TABS ──────────────────────────────────────────────────────────────────── */}
      <div
  style={{
    display: 'flex',
    borderBottom: '2px solid #e2e8f0',
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px #0001',
    overflowX: 'auto',

    position: 'sticky',
    top: 0,
    zIndex: 100,
    flexShrink: 0
  }}
>
          <button
            onClick={() => setActiveTab("business")}
            style={{
              flex: 1,
              minWidth: 145,
              padding: '16px 20px',
              backgroundColor: activeTab === "business" ? '#f0f9ff' : 'transparent',
              borderBottom: activeTab === "business" ? '3px solid #0ea5e9' : 'none',
              color: activeTab === "business" ? '#0369a1' : '#64748b',
              fontWeight: activeTab === "business" ? 600 : 500,
              fontSize: 15,
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              border: 'none',
              textAlign: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            <i className="fa-solid fa-briefcase" style={{ marginRight: 8 }} /> My Business
          </button>
          <button
            onClick={() => setActiveTab("leads")}
            style={{
              flex: 1,
              minWidth: 120,
              padding: '16px 20px',
              backgroundColor: activeTab === "leads" ? '#f0f9ff' : 'transparent',
              borderBottom: activeTab === "leads" ? '3px solid #0ea5e9' : 'none',
              color: activeTab === "leads" ? '#0369a1' : '#64748b',
              fontWeight: activeTab === "leads" ? 600 : 500,
              fontSize: 15,
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              border: 'none',
              textAlign: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            <i className="fa-solid fa-calendar-check" style={{ marginRight: 8 }} /> My Leads
          </button>
          <button
            onClick={() => setActiveTab("catalog")}
            style={{
              flex: 1,
              minWidth: 145,
              padding: '16px 20px',
              backgroundColor: activeTab === "catalog" ? '#f0f9ff' : 'transparent',
              borderBottom: activeTab === "catalog" ? '3px solid #0ea5e9' : 'none',
              color: activeTab === "catalog" ? '#0369a1' : '#64748b',
              fontWeight: activeTab === "catalog" ? 600 : 500,
              fontSize: 15,
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              border: 'none',
              textAlign: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            <i className="fa-solid fa-bag-shopping" style={{ marginRight: 8 }} /> My Catalog
          </button>
          <button
            onClick={() => setActiveTab("reviews")}
            style={{
              flex: 1,
              minWidth: 120,
              padding: '16px 20px',
              backgroundColor: activeTab === "reviews" ? '#f0f9ff' : 'transparent',
              borderBottom: activeTab === "reviews" ? '3px solid #0ea5e9' : 'none',
              color: activeTab === "reviews" ? '#0369a1' : '#64748b',
              fontWeight: activeTab === "reviews" ? 600 : 500,
              fontSize: 15,
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              border: 'none',
              textAlign: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            <i className="fa-solid fa-star" style={{ marginRight: 8 }} /> Reviews
          </button>
          <button
            onClick={() => setActiveTab("seocategories")}
            style={{
              flex: 1,
              minWidth: 170,
              padding: '16px 20px',
              backgroundColor: activeTab === "seocategories" ? '#f0f9ff' : 'transparent',
              borderBottom: activeTab === "seocategories" ? '3px solid #0ea5e9' : 'none',
              color: activeTab === "seocategories" ? '#0369a1' : '#64748b',
              fontWeight: activeTab === "seocategories" ? 600 : 500,
              fontSize: 15,
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              border: 'none',
              textAlign: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            <i className="fa-solid fa-tags" style={{ marginRight: 8 }} /> SEO Categories
          </button>
        </div>

        {/* ── TAB CONTENT ────────────────────────────────────────────────────────────────────────── */}
      <div
  style={{
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '5px'
  }}
>
          {/* ── MY BUSINESS TAB ────────────────────────────────────────────────── */}
          {activeTab === "business" && (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                <div>
                  <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>My Business</h2>
                  <div style={{ marginTop: 6, color: '#64748b', fontSize: 13 }}>
                    New businesses are reviewed by admin before they become visible publicly.
                  </div>
                </div>
                {services.length < MAX_BUSINESSES && (
                <button
                  onClick={openAdd}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    padding: '10px 16px', borderRadius: 8,
                    backgroundColor: '#0ea5e9', color: '#fff',
                    border: 'none', cursor: 'pointer', fontWeight: 600,
                    fontSize: 14, transition: 'all 0.2s ease',
                  }}
                  onMouseOver={e => e.target.style.backgroundColor = '#0284c7'}
                  onMouseOut={e => e.target.style.backgroundColor = '#0ea5e9'}
                >
                  <i className="fa-solid fa-plus" /> Add Business
                </button>
                )}
              </div>

              {loading ? (
                <div style={{ color: '#64748b', fontSize: 15, padding: '32px 16px', textAlign: 'center' }}>
                  <i className="fa-solid fa-circle-notch fa-spin" style={{ marginRight: 8 }} /> Loading businesses…
                </div>
              ) : visible.length === 0 ? (
                <div style={{ color: '#64748b', fontSize: 15, padding: '32px 16px', textAlign: 'center' }}>
                  <i className="fa-solid fa-inbox" style={{ marginRight: 8, fontSize: 24, display: 'block', marginBottom: 8 }} />
                  {search || filterCategories.length > 0 ? "No businesses found matching your filters." : "No businesses yet. Create your first business!"}
                </div>
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 20 }}>
                  {visible.map(service => (
                    <div
                      key={service._id}
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: 12,
                        border: '1px solid #e2e8f0',
                        overflow: 'hidden',
                        boxShadow: '0 2px 8px #0001',
                        transition: 'all 0.3s ease',
                      }}
                      onMouseOver={e => e.currentTarget.style.boxShadow = '0 8px 16px #0002'}
                      onMouseOut={e => e.currentTarget.style.boxShadow = '0 2px 8px #0001'}
                    >
                      {service.photoUrl && (
                        <img
                          src={service.photoUrl}
                          alt={service.businessName}
                          style={{ width: '100%', height: 230, objectFit: 'cover' }}
                        />
                      )}
                      <div style={{ padding: 16 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>{service.businessName}</h3>
                          <span style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            padding: '4px 8px',
                            borderRadius: 999,
                            fontSize: 12,
                            fontWeight: 600,
                            backgroundColor: service.approvalStatus === 'approved' ? '#dcfce7' : service.approvalStatus === 'rejected' ? '#fee2e2' : '#fef3c7',
                            color: service.approvalStatus === 'approved' ? '#166534' : service.approvalStatus === 'rejected' ? '#991b1b' : '#92400e',
                          }}>
                            {service.approvalStatus === 'approved' ? 'Approved' : service.approvalStatus === 'rejected' ? 'Rejected' : 'Pending Approval'}
                          </span>
                        </div>
                        <p style={{ margin: '0 0 12px 0', fontSize: 13, color: '#64748b', lineHeight: 1.4 }}>
                          {service.description || "No description provided"}
                        </p>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
                          {String(service.category || "").split(",").map((cat, idx) => {
                            const style = categoryStyle(cat.trim());
                            return (
                              <span
                                key={idx}
                                style={{
                                  padding: '4px 10px',
                                  borderRadius: 20,
                                  backgroundColor: style.bg,
                                  border: `1px solid ${style.border}`,
                                  color: style.text,
                                  fontSize: 12,
                                  fontWeight: 500,
                                }}
                              >
                                {cat.trim()}
                              </span>
                            );
                          })}
                        </div>
                        <div style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>
                          <div><strong>Phone:</strong> {service.phone}</div>
                          {service.area && <div><strong>Area:</strong> {service.area}</div>}
                          {service.experience && <div><strong>Experience:</strong> {service.experience} years</div>}
                        </div>
                        <div style={{ display: 'flex', gap: 8 }}>
                     
                          <button
                            onClick={() => openEdit(service)}
                            style={{
                              flex: 1,
                              padding: '8px 12px',
                              borderRadius: 6,
                              backgroundColor: '#0ea5e9',
                              color: '#fff',
                              border: 'none',
                              cursor: 'pointer',
                              fontSize: 13,
                              fontWeight: 600,
                              transition: 'all 0.2s ease',
                            }}
                            onMouseOver={e => e.target.style.backgroundColor = '#0284c7'}
                            onMouseOut={e => e.target.style.backgroundColor = '#0ea5e9'}
                          >
                            <i className="fa-solid fa-pen" style={{ marginRight: 4 }} /> Edit
                          </button>
                          <button
                            onClick={() => handleDelete(service._id)}
                            disabled={deleting === service._id}
                            style={{
                              flex: 1,
                              padding: '8px 12px',
                              borderRadius: 6,
                              backgroundColor: deleting === service._id ? '#cbd5e1' : '#ef4444',
                              color: '#fff',
                              border: 'none',
                              cursor: deleting === service._id ? 'not-allowed' : 'pointer',
                              fontSize: 13,
                              fontWeight: 600,
                              transition: 'all 0.2s ease',display:'none'
                            }}
                            onMouseOver={e => !deleting && (e.target.style.backgroundColor = '#dc2626')}
                            onMouseOut={e => !deleting && (e.target.style.backgroundColor = '#ef4444')}
                          >
                            {deleting === service._id ? (
                              <><i className="fa-solid fa-circle-notch fa-spin" style={{ marginRight: 4 }} /> Deleting…</>
                            ) : (
                              <><i className="fa-solid fa-trash" style={{ marginRight: 4 }} /> Delete</>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* ── MY LEADS TAB ────────────────────────────────────────────────────── */}
          {activeTab === "leads" && (
            <div>
              <h2 style={{ margin: '0 0 20px 0', fontSize: 22, fontWeight: 700 }}>My Leads</h2>
              {loadingBookings ? (
                <div style={{ color: '#64748b', fontSize: 15, padding: '32px 16px', textAlign: 'center' }}>
                  <i className="fa-solid fa-circle-notch fa-spin" style={{ marginRight: 8 }} /> Loading leads…
                </div>
              ) : bookings.length === 0 ? (
                <div style={{ color: '#64748b', fontSize: 15, padding: '32px 16px', textAlign: 'center' }}>
                  <i className="fa-solid fa-inbox" style={{ marginRight: 8, fontSize: 24, display: 'block', marginBottom: 8 }} />
                  No leads found yet.
                </div>
              ) : (
                <div style={{ backgroundColor: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 2px 8px #0001' }}>
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', color:"black", borderCollapse: 'collapse', fontSize: 14 }}>
                      <thead>
                        <tr style={{ backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                          <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#334155' }}>Customer</th>
                          <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#334155' }}>Service</th>
                          <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#334155' }}>Category</th>
                          <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#334155' }}>Date</th>
                          <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#334155' }}>Time</th>
                          <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#334155' }}>Address</th>
                          <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#334155' }}>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bookings.map(b => (
                          <tr key={b.id} style={{ borderBottom: '1px solid #e2e8f0' }}>
                            <td
  style={{
    padding: '12px 16px',
    position: 'relative'
  }}
  onMouseEnter={() => setHoveredLead(b.id)}
  onMouseLeave={() => setHoveredLead(null)}
>
  <div>
    {b.customer?.fullName || "N/A"}
    <br />
    <small style={{ color: '#64748b' }}>
      #{b.customer?.userId || b.userId || '-'}
    </small>
  </div>

  {hoveredLead === b.id && (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '100%',
        transform: 'translateY(-50%)',
        background: '#0f172a',
        border: '1px solid rgba(148,163,184,0.15)',
        borderRadius: 10,
        padding: '8px',
        display: 'flex',
        gap: '8px',
        zIndex: 1000,
        boxShadow: '0 12px 30px rgba(15,23,42,0.35)',
      }}
    >
      {/* Chat */}
      <button
        onClick={() =>
          handleChat({
            emails: [b.customer?.email || b.customer?.userId],
            name: b.customer?.fullName
          })
        }
        style={actionBtn}
      >
       <i className="fa-solid fa-comments"></i>
      </button>

      {/* Email */}
      <button
        onClick={() =>
          onOpenComposeModal?.(
            b.customer?.email || b.customer?.userId
          )
        }
        style={actionBtn}
      >
       <i className="fa-solid fa-envelope"></i>
      </button>

      {/* Call */}
      <button
        onClick={() =>
          makeVoiceCall(
            b.customer?.email || b.customer?.userId
          )
        }
        style={actionBtn}
      >
        <i className="fa-solid fa-phone"></i>
      </button>
    </div>
  )}
</td>
                            <td style={{ padding: '12px 16px' }}>{b.serviceInfo?.category || b.serviceName || '-'}</td>
                            <td style={{ padding: '12px 16px' }}>{b.serviceCategory || '-'}</td>
                            <td style={{ padding: '12px 16px', width: '120px' }}>{b.scheduledDate || '-'}</td>
                            <td style={{ padding: '12px 16px' }}>{b.scheduledTime || '-'}</td>
                            <td style={{ padding: '12px 16px', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.address || '-'}</td>
                            <td style={{ padding: '12px 16px' }}>
                              <span style={{
                                display: 'inline-block',
                                padding: '4px 10px',
                                borderRadius: 20,
                                fontSize: 12,
                                fontWeight: 600,
                                backgroundColor: b.status === 'pending' ? '#fef3c7'
                                  : b.status === 'confirmed' ? '#d1fae5'
                                  : b.status === 'completed' ? '#cffafe'
                                  : '#fee2e2',
                                color: b.status === 'pending' ? '#92400e'
                                  : b.status === 'confirmed' ? '#065f46'
                                  : b.status === 'completed' ? '#164e63'
                                  : '#7f1d1d',
                              }}>
                                {b.status}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* ── MY CATALOG TAB ────────────────────────────────────────────────────── */}
          {activeTab === "catalog" && (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>My Catalog</h2>
              {/* In your catalog tab header */}
{services.length > 0 && (() => {
  const targetService = services[0];
  const currentCount = targetService ? (targetService.catalogItems?.length || 0) : 0;
  return currentCount < MAX_CATALOG ? (
    <button onClick={openAddCatalogItem}  style={{
                      display: 'flex', alignItems: 'center', gap: 8,
                      padding: '10px 16px', borderRadius: 8,
                      backgroundColor: '#0ea5e9', color: '#fff',
                      border: 'none', cursor: 'pointer', fontWeight: 600,
                      fontSize: 14, transition: 'all 0.2s ease',
                    }}>
      <i className="fa-solid fa-plus" /> Add Catalog Item New
    </button>
  ) : (
    <span style={{ fontSize: 13, color: '#64748b', padding: '10px 16px', background: '#f1f5f9', borderRadius: 8 }}>
      ✅ Catalog full ({MAX_CATALOG}/{MAX_CATALOG} items)
    </span>
  );
})()}
                
              </div>

              {services.length === 0 ? (
                <div style={{ color: '#64748b', fontSize: 15, padding: '32px 16px', textAlign: 'center', backgroundColor: '#f8fafc', borderRadius: 12, border: '1px dashed #cbd5e1' }}>
                  <i className="fa-solid fa-inbox" style={{ marginRight: 8, fontSize: 24, display: 'block', marginBottom: 8 }} />
                  Create a business first to add catalog items.
                </div>
              ) : catalogItems.length === 0 ? (
                <div style={{ color: '#64748b', fontSize: 15, padding: '32px 16px', textAlign: 'center', backgroundColor: '#f8fafc', borderRadius: 12, border: '1px dashed #cbd5e1' }}>
                  <i className="fa-solid fa-inbox" style={{ marginRight: 8, fontSize: 24, display: 'block', marginBottom: 8 }} />
                  No catalog items yet. Add your first catalog item!
                </div>
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 20 }}>
                  {catalogItems.map((item, idx) => (
                    <div
                      key={idx}
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: 12,
                        border: '1px solid #e2e8f0',
                        overflow: 'hidden',
                        boxShadow: '0 2px 8px #0001',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                      onMouseOver={e => e.currentTarget.style.boxShadow = '0 8px 16px #0002'}
                      onMouseOut={e => e.currentTarget.style.boxShadow = '0 2px 8px #0001'}
                    >
                      {item.photoUrl && (
                        <img
                          src={item.photoUrl}
                          alt={item.title}
                          style={{ width: '100%', height: 160, objectFit: 'cover' }}
                        />
                      )}
                      <div style={{ padding: 16, flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>{item.title}</h3>
                          <span style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            padding: '4px 8px',
                            borderRadius: 999,
                            fontSize: 11,
                            fontWeight: 600,
                            backgroundColor: item.approvalStatus === 'approved' ? '#dcfce7' : item.approvalStatus === 'rejected' ? '#fee2e2' : '#fef3c7',
                            color: item.approvalStatus === 'approved' ? '#166534' : item.approvalStatus === 'rejected' ? '#991b1b' : '#92400e',
                          }}>
                            {item.approvalStatus === 'approved' ? 'Approved' : item.approvalStatus === 'rejected' ? 'Rejected' : 'Pending Approval'}
                          </span>
                        </div>
                        <p style={{ margin: '0 0 8px 0', fontSize: 12, color: '#64748b', lineHeight: 1.4, flex: 1 }}>
                          {item.description || "No description"}
                        </p>
                        <div style={{ marginBottom: 12 }}>
                          {item.category && (
                            <span style={{
                              display: 'inline-block',
                              padding: '4px 10px',
                              borderRadius: 20,
                              backgroundColor: '#e0f2fe',
                              color: '#0369a1',
                              fontSize: 11,
                              fontWeight: 600,
                            }}>
                              {item.category}
                            </span>
                          )}
                        </div>
                        <div style={{ fontSize: 13, color: '#334155', marginBottom: 12, fontWeight: 600 }}>
                          ₹{item.price || "N/A"}
                        </div>
                        <div style={{ fontSize: 12, color: '#64748b', marginBottom: 12 }}>
                          <strong>Business:</strong> {item.businessName}
                        </div>
                        <div style={{ display: 'flex', gap: 8 }}>
                          <button
                            onClick={() => {
                              const service = services.find(s => s._id === item.serviceId);
                              if (service) {
                                const itemIndex = (service.catalogItems || []).findIndex(ci => ci.title === item.title && ci.description === item.description);
                                if (itemIndex !== -1) {
                                  openEditCatalogItem(item.serviceId, item, itemIndex);
                                }
                              }
                            }}
                            style={{
                              flex: 1,
                              padding: '8px 12px',
                              borderRadius: 6,
                              backgroundColor: '#0ea5e9',
                              color: '#fff',
                              border: 'none',
                              cursor: 'pointer',
                              fontSize: 12,
                              fontWeight: 600,
                              transition: 'all 0.2s ease',
                            }}
                            onMouseOver={e => e.target.style.backgroundColor = '#0284c7'}
                            onMouseOut={e => e.target.style.backgroundColor = '#0ea5e9'}
                          >
                            <i className="fa-solid fa-pen" style={{ marginRight: 4 }} /> Edit
                          </button>
                          <button
                            onClick={() => handleRemoveCatalogItem(item.serviceId, catalogItems.findIndex(ci => ci === item))}
                            style={{
                              flex: 1,
                              padding: '8px 12px',
                              borderRadius: 6,
                              backgroundColor: '#ef4444',
                              color: '#fff',
                              border: 'none',
                              cursor: 'pointer',
                              fontSize: 12,
                              fontWeight: 600,
                              transition: 'all 0.2s ease',
                            }}
                            onMouseOver={e => e.target.style.backgroundColor = '#dc2626'}
                            onMouseOut={e => e.target.style.backgroundColor = '#ef4444'}
                          >
                            <i className="fa-solid fa-trash" style={{ marginRight: 4 }} /> Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
      
      
       
        {/* ── REVIEWS TAB ────────────────────────────────────────────────── */}
        {activeTab === "reviews" && (
          <div>
            <h2 style={{ margin: '0 0 20px 0', fontSize: 22, fontWeight: 700 }}>Customer Reviews</h2>
            <div style={{ color: '#64748b', fontSize: 15, padding: '60px 16px', textAlign: 'center', backgroundColor: '#f8fafc', borderRadius: 12, border: '1px dashed #cbd5e1' }}>
              <i className="fa-solid fa-star" style={{ marginRight: 8, fontSize: 32, display: 'block', marginBottom: 8 }} />
              No reviews yet. Start providing great service to receive reviews from customers!
            </div>
          </div>
        )}

         {activeTab === "seocategories" && (
          <div>
            <h2 style={{ margin: '0 0 24px 0', fontSize: 22, fontWeight: 700 }}>SEO Categories</h2>

              {services.length === 0 ? (
            <div style={{ color: '#64748b', fontSize: 15, padding: '32px 16px', textAlign: 'center', backgroundColor: '#f8fafc', borderRadius: 12, border: '1px dashed #cbd5e1' }}>
              <i className="fa-solid fa-inbox" style={{ fontSize: 24, display: 'block', marginBottom: 8 }} />
              No businesses found. Create a business first.
            </div>
          ) : (
        <div className="secocatcss"
>
              {services.map(service => (
        <BusinessCategoryCard
          key={service._id}
          service={service}
          seoCategories={seoCategories}
          authHeader={authHeader}
          showToast={showToast}
          fetchServices={fetchServices}
        />
      ))}
            </div>
          )}
          </div>
        )}


     </div>

      {toast && (
        <div className={`svc-toast ${toast.type}`}>
          <i className={`fa-solid ${toast.type === "success" ? "fa-circle-check" : "fa-circle-exclamation"}`} />
          {toast.msg}
        </div>
      )}

    

      {editorOpen && (
       <div className="svc-modal-overlay" style={{ zIndex: 9999 }} onClick={e => { if (e.target === e.currentTarget) setEditorOpen(false); }}>
    <div className="svc-modal" style={{ maxWidth: 760, zIndex: 10000 }}>
            <div className="svc-modal-header">
              <span className="svc-modal-title"><i className="fa-solid fa-image" /> Adjust Image</span>
              <button className="svc-modal-close" onClick={() => setEditorOpen(false)}><i className="fa-solid fa-xmark" /></button>
            </div>
            <div style={{ padding: 16 }}>
              <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
                <div style={{ flex: '1 1 auto' }}>
                  <canvas
                    ref={canvasRef}
                    style={{ width: '100%', borderRadius: 8, background: '#fff', boxShadow: '0 2px 6px #0001', cursor: editorDragging ? 'grabbing' : 'grab', touchAction: 'none' }}
                    onPointerDown={e => {
                      e.currentTarget.setPointerCapture(e.pointerId);
                      startDrag(e.clientX, e.clientY);
                    }}
                    onPointerMove={e => moveDrag(e.clientX, e.clientY)}
                    onPointerUp={e => {
                      endDrag();
                      e.currentTarget.releasePointerCapture(e.pointerId);
                    }}
                    onPointerCancel={endDrag}
                  />
                </div>
                <div style={{ width: 220 }}>
                  <label style={{ display: 'block', marginBottom: 8 }}>Scale</label>
                  <input type="range" min="0.5" max="2" step="0.05" value={editorScale} onChange={e => setEditorScale(Number(e.target.value))} />
                  <label style={{ display: 'block', marginTop: 12, marginBottom: 8 }}>Rotate</label>
                  <input type="range" min="-180" max="180" step="1" value={editorRotate} onChange={e => setEditorRotate(Number(e.target.value))} />
                  <div style={{ marginTop: 16, display: 'flex', gap: 8, flexDirection: 'column' }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button className="svc-btn" onClick={() => {
                        setEditorScale(1);
                        setEditorRotate(0);
                        setEditorOffsetX(0);
                        setEditorOffsetY(0);
                      }}>Fit</button>
                      <button className="svc-btn-cancel" onClick={() => { setEditorScale(1); setEditorRotate(0); setEditorOffsetX(0); setEditorOffsetY(0); }}>Reset</button>
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button className="svc-btn-cancel" onClick={() => setEditorOpen(false)}>Cancel</button>
                      <button className="svc-btn-save" onClick={async () => {
                        try {
                          await saveEditedImage(canvasRef.current);
                          setEditorOpen(false);
                          showToast('Image adjusted.');
                        } catch (err) {
                          console.error('[saveEditedImage]', err);
                          showToast('Failed to save edited image.', 'error');
                        }
                      }}>Save</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div className="svc-modal-overlay" style={{ zIndex: 1000 }} onClick={e => { if (e.target === e.currentTarget) closeModal(); }}>
          <div className="svc-modal" style={{ zIndex: 1001 }}>
            <div className="svc-modal-header">
              <span className="svc-modal-title">
                <i className={`fa-solid ${editing ? "fa-pen" : "fa-plus"}`} />
                {modalMode === "catalog"
                  ? (editing ? " Edit Catalog Item" : " Add Catalog Item")
                  : (editing ? " Edit Business" : " Add Business")}
              </span>
              <button className="svc-modal-close" onClick={closeModal}><i className="fa-solid fa-xmark" /></button>
            </div>

            <form className="svc-modal-form" onSubmit={handleSubmit}>
              {modalMode === "seocategory" ? (
                <>
                  <div className="svc-field">
                    <label>SEO Category Name <span className="req">*</span></label>
                    <input name="seoName" value={form.seoName || ""} onChange={handleChange} placeholder="e.g. Digital Marketing, Web Design" required />
                  </div>

                  <div className="svc-field">
                    <label>Keywords</label>
                    <input name="seoKeywords" value={form.seoKeywords || ""} onChange={handleChange} placeholder="e.g. SEO, digital marketing, online services" />
                  </div>

                  <div className="svc-field">
                    <label>Description</label>
                    <textarea name="seoDescription" rows={3} value={form.seoDescription || ""}
                      onChange={handleChange} placeholder="Brief description for this SEO category…" />
                  </div>
                </>
              ) : modalMode === "business" ? (
                <>
                  <div className="svc-field">
                    <label>Business Name</label>
                    <input name="businessName" value={form.businessName} onChange={handleChange} placeholder="Business name" />
                  </div>

                  <div className="svc-field">
                    <label>Category <span className="req">*</span></label>
                    <select name="category" value={form.category} onChange={handleChange} required>
                      <option value="">Select a category...</option>
                      {(categories && categories.length ? categories : ["Plumber","Electrician","Carpenter","Painter","Cleaning","AC Repair","Appliance Repair","Pest Control","Security","Other"]).map(c => {
                        const name = typeof c === 'string' ? c : (c.name || c.category || String(c));
                        return <option key={name} value={name}>{name}</option>;
                      })}
                    </select>
                  </div>

                  <div className="svc-row-2">
                    <div className="svc-field">
                      <label>Phone</label>
                      <input name="phone" value={form.phone} onChange={handleChange}
                        placeholder="+91 98765 43210" />
                    </div>
                    <div className="svc-field">
                      <label>Experience (years)</label>
                      <input name="experience" type="number" min="0" max="60"
                        value={form.experience} onChange={handleChange} placeholder="e.g. 5" />
                    </div>
                  </div>

                  <div className="svc-row-2">
                    <div className="svc-field">
                      <label>Service Area</label>
                      <input name="area" value={form.area} onChange={handleChange} placeholder="e.g. Baner, Hinjewadi" />
                    </div>
                    <div className="svc-field">
                      <label>City</label>
                      <input name="city" value={form.city} onChange={handleChange} placeholder="e.g. Pune" />
                    </div>
                  </div>
                    <div className="svc-row-2">
                       <div className="svc-field">
                      <label>Pincode</label>
                      <input name="pincode" value={form.pincode} onChange={handleChange} placeholder="e.g. 411001" />
                    </div>
                    <div className="svc-field">
                      <label>Website</label>
                      <input name="website" value={form.website} onChange={handleChange} placeholder="e.g. https://example.com" />
                    </div>
                  </div>

                  <div className="svc-field">
                    <label>Description</label>
                    <textarea name="description" rows={3} value={form.description}
                      onChange={handleChange} placeholder="Briefly describe your service…" />
                  </div>

                  <div className="svc-row-2">
                    <div className="svc-field">
                      <label>Latitude</label>
                      <input
                        name="lat"
                        type="number"
                        step="any"
                        value={form.lat}
                        onChange={handleChange}
                        placeholder="e.g. 18.5204"
                      />
                    </div>
                    <div className="svc-field">
                      <label>Longitude</label>
                      <input
                        name="lng"
                        type="number"
                        step="any"
                        value={form.lng}
                        onChange={handleChange}
                        placeholder="e.g. 73.8567"
                      />
                    </div>
                  </div>
                  <div style={{ marginBottom: 12 }}>
                    <button type="button" className="svc-btn-save" style={{ fontSize: 14, padding: '4px 12px' }} onClick={handleUseLocation}>
                      <i className="fa-solid fa-location-crosshairs" style={{ marginRight: 6 }} /> Use My Location
                    </button>
                  </div>

                  <div className="svc-field">
                    <label>Business Image</label>
                    <div className="svc-file-wrap">
                      <label className="svc-file-btn">
                        <i className="fa-solid fa-image" /> Choose business image
                        <input type="file" name="photo" accept="image/*" onChange={handleChange} hidden />
                      </label>
                      {(previewUrl || form.photoUrl) ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginLeft: 8 }}>
                          <img src={previewUrl || form.photoUrl} alt="preview" style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 8, border: '1px solid #e6eef5' }} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span className="svc-file-name">{form.photo?.name || 'Current image'}</span>
                            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                              <button type="button" className="svc-btn" onClick={openEditor}>Adjust Image</button>
                              <button type="button" className="svc-btn-cancel" onClick={() => { setForm(p => ({ ...p, photo: null, photoUrl: '' })); try { URL.revokeObjectURL(previewUrl); } catch (e) {} setPreviewUrl(null); }}>Remove</button>
                            </div>
                          </div>
                        </div>
                      ) : form.photo ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginLeft: 8 }}>
                          <span className="svc-file-name">{form.photo.name}</span>
                          <button type="button" className="svc-btn" onClick={openEditor}>Adjust Image</button>
                        </div>
                      ) : null}
                    </div>
                  </div>
<div className="svc-field">
                    <label>Business Certificate <span className="req">*</span></label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <button
                        type="button"
                        className="svc-btn"
                        onClick={() => document.querySelector('input[name="certificate"]').click()}
                      >
                        Upload Certificate
                      </button>
                      {form.certificate ? (
                        <span className="svc-file-name">{form.certificate.name}</span>
                      ) : null}
                    </div>
                    <input
                      type="file"
                      name="certificate"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleChange}
                      hidden
                    />
                  </div>
                  <div className="svc-field">
                    <label>GST / License Document <span className="req">*</span></label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <button
                        type="button"
                        className="svc-btn"
                        onClick={() => document.querySelector('input[name="license"]').click()}
                      >
                        Upload License
                      </button>
                      {form.license ? (
                        <span className="svc-file-name">{form.license.name}</span>
                      ) : null}
                    </div>
                    <input
                      type="file"
                      name="license"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleChange}
                      hidden
                    />
                  </div>
                  <label className="svc-checkbox">
                    <input type="checkbox" name="homeVisit" checked={form.homeVisit} onChange={handleChange} />
                    <span>Home Visit Available</span>
                  </label>
                </>
              ) : (
                <>
                  <div className="svc-field">
                    <label>Business <span className="req">*</span></label>
                    <select name="businessId" value={form.businessId} onChange={handleChange} required>
                      <option value="">Select business…</option>
                      {services.map(s => (
                        <option key={s._id} value={s._id}>{s.businessName || s.category || `Business ${s._id.slice(0, 6)}`}</option>
                      ))}
                    </select>
                  </div>

                  <div className="svc-field">
                    <label>Catalog Category</label>
                  <select
  name="category"
  value={form.category}
  onChange={handleChange}
  required
  size={8}
  style={{
    maxHeight: "220px",
    overflowY: "auto"
  }}
>
                      <option value="">Select category…</option>
                      {(categories && categories.length ? categories : ["Plumber","Electrician","Carpenter","Painter","Cleaning","AC Repair","Appliance Repair","Pest Control","Security","Other"]).map(c => {
                        const name = typeof c === 'string' ? c : (c.name || c.category || String(c));
                        return <option key={name} value={name}>{name}</option>;
                      })}
                    </select>
                  </div>

                  <div className="svc-field">
                    <label>Title <span className="req">*</span></label>
                    <input name="catalogTitle" value={form.catalogTitle} onChange={handleChange} placeholder="Catalog item title" required />
                  </div>

                  <div className="svc-field">
                    <label>Description</label>
                    <textarea name="catalogDescription" rows={3} value={form.catalogDescription} onChange={handleChange} placeholder="Item description" />
                  </div>

                  <div className="svc-field">
                    <label>Price</label>
                    <input name="catalogPrice" type="number" min="0" step="0.01" value={form.catalogPrice} onChange={handleChange} placeholder="e.g. 499" />
                  </div>

                  <div className="svc-field">
                    <label>Catalog Image</label>
                    <div className="svc-file-wrap">
                      <label className="svc-file-btn">
                        <i className="fa-solid fa-image" /> Choose catalog image
                        <input type="file" name="catalogPhoto" accept="image/*" onChange={handleChange} hidden />
                      </label>
                      {(previewUrl || form.catalogPhotoUrl) ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginLeft: 8 }}>
                          <img src={previewUrl || form.catalogPhotoUrl} alt="preview" style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 8, border: '1px solid #e6eef5' }} />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span className="svc-file-name">{form.catalogPhoto?.name || 'Current image'}</span>
                            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                              <button type="button" className="svc-btn" onClick={openEditor}>Adjust Image</button>
                              <button type="button" className="svc-btn-cancel" onClick={() => { setForm(p => ({ ...p, catalogPhoto: null, catalogPhotoUrl: '' })); try { URL.revokeObjectURL(previewUrl); } catch (e) {} setPreviewUrl(null); }}>Remove</button>
                            </div>
                          </div>
                        </div>
                      ) : form.catalogPhoto ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginLeft: 8 }}>
                          <span className="svc-file-name">{form.catalogPhoto.name}</span>
                          <button type="button" className="svc-btn" onClick={openEditor}>Adjust Image</button>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </>
              )}

              <div className="svc-modal-actions">
                <button type="button" className="svc-btn-cancel" onClick={closeModal}>Cancel</button>
                <button type="submit" className="svc-btn-save" disabled={submitting}>
                  {submitting
                    ? <><i className="fa-solid fa-circle-notch fa-spin" /> Saving…</>
                    : <><i className="fa-solid fa-check" /> {modalMode === "business" ? (editing ? "Update" : "Add Business") : "Add Catalog Item"}</>}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      </div>
        {isMobile && <MobileBottomNav activeTab={activeTab} setActiveTab={setActiveTab} />}
    </div>
   
  );
}
